import React, { useState, useEffect } from 'react'
import { supabase } from '../lib/supabase'

export default function Dashboard({ profile }) {
  const [registros, setRegistros] = useState([])
  const [loading, setLoading] = useState(true)
  const [showModal, setShowModal] = useState(false)
  const [editando, setEditando] = useState(null)
  const [form, setForm] = useState({
    fecha: new Date().toISOString().split('T')[0],
    par_divisas: '',
    sesion: '',
    direccion: 'Long',
    timeframe: '',
    rr: '',
    take_profit: '',
    stop_loss: '',
    resultado: '',
    enlace: '',
    tipo_entrada: '',
    notas: '',
    comentario: ''
  })
  const [saving, setSaving] = useState(false)

  useEffect(() => { fetchRegistros() }, [])

  async function fetchRegistros() {
    const { data } = await supabase
      .from('journal_personal')
      .select('*')
      .order('fecha', { ascending: false })
    setRegistros(data || [])
    setLoading(false)
  }

  function openNew() {
    setEditando(null)
    setForm({ fecha: new Date().toISOString().split('T')[0], par_divisas: '', sesion: '', direccion: 'Long', timeframe: '', rr: '', take_profit: '', stop_loss: '', resultado: '', enlace: '', tipo_entrada: '', notas: '', comentario: '' })
    setShowModal(true)
  }

  function openEdit(r) {
    setEditando(r)
    setForm({ fecha: r.fecha, par_divisas: r.par_divisas, sesion: r.sesion || '', direccion: r.direccion, timeframe: r.timeframe || '', rr: r.rr || '', take_profit: r.take_profit || '', stop_loss: r.stop_loss || '', resultado: r.resultado || '', enlace: r.enlace || '', tipo_entrada: r.tipo_entrada || '', notas: r.notas || '', comentario: r.comentario || '' })
    setShowModal(true)
  }

  async function handleSave() {
    if (!form.par_divisas || !form.fecha) return
    setSaving(true)
    const payload = {
      fecha: form.fecha,
      par_divisas: form.par_divisas.toUpperCase(),
      sesion: form.sesion || null,
      direccion: form.direccion,
      timeframe: form.timeframe || null,
      rr: form.rr !== '' ? parseFloat(form.rr) : null,
      take_profit: form.take_profit !== '' ? parseFloat(form.take_profit) : null,
      stop_loss: form.stop_loss !== '' ? parseFloat(form.stop_loss) : null,
      resultado: form.resultado !== '' ? parseFloat(form.resultado) : null,
      enlace: form.enlace || null,
      tipo_entrada: form.tipo_entrada || null,
      notas: form.notas || null,
      comentario: form.comentario || null,
    }
    if (editando) {
      await supabase.from('journal_personal').update(payload).eq('id', editando.id)
    } else {
      await supabase.from('journal_personal').insert({ ...payload, user_id: profile.id })
    }
    await fetchRegistros()
    setShowModal(false)
    setSaving(false)
  }

  async function handleDelete(id) {
    if (!window.confirm('¿Eliminar este registro?')) return
    await supabase.from('journal_personal').delete().eq('id', id)
    fetchRegistros()
  }

  async function handleLogout() {
    await supabase.auth.signOut()
  }

  const total = registros.length
  const ganancias = registros.filter(r => r.resultado > 0).length
  const perdidas = registros.filter(r => r.resultado < 0).length
  const pnlTotal = registros.reduce((sum, r) => sum + (r.resultado || 0), 0)

  return (
    <div className="dashboard">
      <header className="topbar">
        <img src="/logo.png" alt="Trading Women" className="topbar-brand" />
        <div className="topbar-right">
          <span className="topbar-role">Mi Journal</span>
          <span className="topbar-user">{profile?.nombre || profile?.email}</span>
          <button className="btn-logout" onClick={handleLogout}>Salir</button>
        </div>
      </header>
      <main className="main-content">
        <div className="page-header">
          <div>
            <div className="page-title">Mi Journal Personal</div>
            <div className="page-subtitle">Registro privado de operaciones</div>
          </div>
          <button className="btn-primary" style={{ width: 'auto', padding: '12px 28px' }} onClick={openNew}>+ Nueva operación</button>
        </div>
        <div className="stats-row">
          <div className="stat-box"><div className="stat-label">Total operaciones</div><div className="stat-value">{total}</div></div>
          <div className="stat-box"><div className="stat-label">Ganancias</div><div className="stat-value positive">{ganancias}</div></div>
          <div className="stat-box"><div className="stat-label">Pérdidas</div><div className="stat-value negative">{perdidas}</div></div>
          <div className="stat-box"><div className="stat-label">P&L Total</div><div className={`stat-value ${pnlTotal >= 0 ? 'positive' : 'negative'}`}>{pnlTotal >= 0 ? '+' : ''}{pnlTotal.toFixed(2)}</div></div>
        </div>
        <div className="table-wrap">
          {loading ? (
            <div className="empty-state"><p>Cargando...</p></div>
          ) : registros.length === 0 ? (
            <div className="empty-state"><div className="empty-state-icon">📊</div><p>Sin operaciones registradas</p></div>
          ) : (
            <table className="data-table">
              <thead>
                <tr>
                  <th>Fecha</th><th>Par</th><th>Sesion</th><th>Dirección</th><th>Timeframe</th>
                  <th>RR</th><th>Take Profit</th><th>Stop Loss</th><th>Resultado</th>
                  <th>Tipo Entrada</th><th>Enlace</th><th>Notas</th><th>Comentario</th><th></th>
                </tr>
              </thead>
              <tbody>
                {registros.map(r => (
                  <tr key={r.id}>
                    <td>{r.fecha}</td>
                    <td style={{ color: 'var(--text)', fontWeight: 500 }}>{r.par_divisas}</td>
                    <td>{r.sesion || '-'}</td>
                    <td><span className={`badge ${r.direccion === 'Long' || r.direccion === 'Compra' ? 'badge-buy' : 'badge-sell'}`}>{r.direccion}</span></td>
                    <td>{r.timeframe || '-'}</td>
                    <td>{r.rr || '-'}</td>
                    <td>{r.take_profit || '-'}</td>
                    <td>{r.stop_loss || '-'}</td>
                    <td>{r.resultado !== null ? (<span className={r.resultado >= 0 ? 'result-positive' : 'result-negative'}>{r.resultado >= 0 ? '+' : ''}{r.resultado}</span>) : '-'}</td>
                    <td>{r.tipo_entrada || '-'}</td>
                    <td>{r.enlace ? (<a href={r.enlace} target="_blank" rel="noreferrer" className="link-btn">Ver →</a>) : '-'}</td>
                    <td style={{ maxWidth: 150, fontSize: 11, color: 'var(--text2)' }}>{r.notas || '-'}</td>
                    <td style={{ maxWidth: 150, fontSize: 11, color: 'var(--text2)' }}>{r.comentario || '-'}</td>
                    <td>
                      <div style={{ display: 'flex', gap: 8 }}>
                        <button className="btn-secondary" onClick={() => openEdit(r)}>Editar</button>
                        <button className="btn-secondary" style={{ borderColor: 'rgba(224,92,92,0.3)', color: 'var(--red)' }} onClick={() => handleDelete(r.id)}>🗑</button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </main>
      {showModal && (
        <div className="modal-overlay" onClick={e => e.target === e.currentTarget && setShowModal(false)}>
          <div className="modal">
            <div className="modal-title">{editando ? 'Editar operación' : 'Nueva operación'}</div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
              <div className="form-group"><label className="form-label">Fecha</label><input className="form-input" type="date" value={form.fecha} onChange={e => setForm({ ...form, fecha: e.target.value })} /></div>
              <div className="form-group"><label className="form-label">Par de divisas</label><input className="form-input" type="text" placeholder="EUR/USD..." value={form.par_divisas} onChange={e => setForm({ ...form, par_divisas: e.target.value })} /></div>
              <div className="form-group"><label className="form-label">Sesion</label><select className="form-select" value={form.sesion} onChange={e => setForm({ ...form, sesion: e.target.value })}><option value="">Seleccionar...</option><option value="Londres">Londres</option><option value="Nueva York">Nueva York</option><option value="Asia">Asia</option><option value="Sidney">Sidney</option></select></div>
              <div className="form-group"><label className="form-label">Dirección</label><select className="form-select" value={form.direccion} onChange={e => setForm({ ...form, direccion: e.target.value })}><option value="Long">Long</option><option value="Short">Short</option></select></div>
              <div className="form-group"><label className="form-label">Timeframe</label><select className="form-select" value={form.timeframe} onChange={e => setForm({ ...form, timeframe: e.target.value })}><option value="">Seleccionar...</option><option value="1m">1m</option><option value="5m">5m</option><option value="15m">15m</option><option value="30m">30m</option><option value="1h">1h</option><option value="4h">4h</option><option value="1D">1D</option><option value="1W">1W</option></select></div>
              <div className="form-group"><label className="form-label">RR</label><input className="form-input" type="number" step="0.1" placeholder="ej: 2.5" value={form.rr} onChange={e => setForm({ ...form, rr: e.target.value })} /></div>
              <div className="form-group"><label className="form-label">Take Profit</label><input className="form-input" type="number" step="0.01" placeholder="ej: 1.1250" value={form.take_profit} onChange={e => setForm({ ...form, take_profit: e.target.value })} /></div>
              <div className="form-group"><label className="form-label">Stop Loss</label><input className="form-input" type="number" step="0.01" placeholder="ej: 1.1200" value={form.stop_loss} onChange={e => setForm({ ...form, stop_loss: e.target.value })} /></div>
              <div className="form-group"><label className="form-label">Resultado (pips / %)</label><input className="form-input" type="number" step="0.01" placeholder="ej: 45.5 o -12.3" value={form.resultado} onChange={e => setForm({ ...form, resultado: e.target.value })} /></div>
              <div className="form-group"><label className="form-label">Tipo de entrada</label><input className="form-input" type="text" placeholder="ej: Ruptura, Retroceso..." value={form.tipo_entrada} onChange={e => setForm({ ...form, tipo_entrada: e.target.value })} /></div>
              <div className="form-group" style={{ gridColumn: '1 / -1' }}><label className="form-label">Enlace</label><input className="form-input" type="url" placeholder="https://..." value={form.enlace} onChange={e => setForm({ ...form, enlace: e.target.value })} /></div>
              <div className="form-group" style={{ gridColumn: '1 / -1' }}><label className="form-label">Notas personales</label><textarea className="form-input" rows={3} placeholder="Reflexiones, aprendizajes, emociones..." value={form.notas} onChange={e => setForm({ ...form, notas: e.target.value })} style={{ resize: 'vertical' }} /></div>
              <div className="form-group" style={{ gridColumn: '1 / -1' }}><label className="form-label">Comentario</label><textarea className="form-input" rows={2} placeholder="Añade un comentario sobre esta operación......" value={form.comentario} onChange={e => setForm({ ...form, comentario: e.target.value })} style={{ resize: 'vertical' }} /></div>
            </div>
            <div className="modal-footer">
              <button className="btn-secondary" onClick={() => setShowModal(false)}>Cancelar</button>
              <button className="btn-primary" style={{ width: 'auto', padding: '12px 28px' }} onClick={handleSave} disabled={saving}>{saving ? 'Guardando...' : 'Guardar'}</button>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}
